import { EstablishmentsActionType } from '../features/settings/actions/establishmentsActions';
import { EstablishmentsActions } from '../features/settings/actions/establishmentsActions';
import { put, takeLatest, call, all } from 'redux-saga/effects';
import { Services } from '@card/commonlib';

type assignationToSendType = {
  assignations: {
    establishmentId: string;
    shopId: string;
  }[];
  credentialId: string;
  assignAll: boolean;
};

type AssignAllEstablishmentsActionType = {
  type: string;
  error: boolean;
  payload: assignationToSendType;
  meta: undefined;
};

type EstablishmentActionType = {
  type: string;
  error: boolean;
  payload: {
    establishmentId: string;
    shopId: string;
    credentialId: string;
  };
  meta: undefined;
};

function* assignShop(actionType: EstablishmentActionType) {
  const params = {
    id: actionType.payload.establishmentId,
    // eslint-disable-next-line @typescript-eslint/camelcase
    params: { shop_id: actionType.payload.shopId }
  };
  try {
    yield call(Services.updateEstablishment, params.id, params.params);
    yield put(EstablishmentsActions.assignShopSuccess());
  } catch (error) {
    yield put(EstablishmentsActions.assignShopFailed(error));
  }
}

function* assignAllEstablishments(actionType: AssignAllEstablishmentsActionType) {
  try {
    const calls = actionType.payload.assignations.map(
      (assignationToSend: { establishmentId: string; shopId: string }) => {
        const params = {
          id: assignationToSend.establishmentId,
          // eslint-disable-next-line @typescript-eslint/camelcase
          params: { shop_id: assignationToSend.shopId }
        };
        return call(Services.updateEstablishment, params.id, params.params);
      }
    );
    yield all(calls);
    yield put(EstablishmentsActions.assignAllEstablishmentsSuccess());
  } catch (error) {
    yield put(EstablishmentsActions.assignAllEstablishmentsFailed(error));
  }
}

function* establishmentSagas() {
  yield takeLatest(EstablishmentsActionType.AssignShop, assignShop);
  yield takeLatest(EstablishmentsActionType.AssignAllEstablishments, assignAllEstablishments);
}

export default establishmentSagas;
